// React imports
import React from 'react';
import ReactDOM from 'react-dom';

// Spectrum components
import Wait from '@react/react-spectrum/Wait';

// Styles
import '../css/Loader.scss';


const Loader = () => ReactDOM.createPortal(
  <div className="spectrum spectrum--light spectrum--medium cmp-loading-indicator">
    <Wait size="L" />
  </div>,
  document.getElementById('loader'),
);

export default Loader;
